import { Navbar } from '../navbar';

document.addEventListener('DOMContentLoaded', () => {
    const navbar = new Navbar();
    navbar.setupNavbar();
});
